import React, { Component } from 'react'
import { Form, Button } from 'devextreme-react'
import { addURL } from 'redux/actions/url';
import { banks, participants, pensiunType, product, tipePembayaranMp } from 'dataSource/lookup';
import httpRequest from 'plugin/httprequest';
import reportRequest, { reportFile } from 'plugin/reportRequest'
import { formatDate, formatDefaultDate, formatNumber, generateExcelFile, PrintElem } from 'plugin/helper'
import * as XLSX from 'xlsx';
import Excel from 'exceljs/dist/exceljs';
import saveAs from "file-saver";
import { showLoading } from 'redux/actions/loading';
import DevExpressDataGrid from 'components/inheritComponent/devexpressdatagrid'
import notify from 'devextreme/ui/notify'
import { read } from 'fs-extra';

const bulan = [
    {
        id: 1,
        namaBulan: 'Januari'
    },
    {
        id: 2,
        namaBulan: 'Februari'
    },
    {
        id: 3,
        namaBulan: 'Maret'
    },
    {
        id: 4,
        namaBulan: 'April'
    },
    {
        id: 5,
        namaBulan: 'Mei'
    },
    {
        id: 6,
        namaBulan: 'Juni'
    },
    {
        id: 7,
        namaBulan: 'Juli'
    },
    {
        id: 8,
        namaBulan: 'Agustus'
    },
    {
        id: 9,
        namaBulan: 'September'
    },
    {
        id: 10,
        namaBulan: 'Oktober'
    },
    {
        id: 11,
        namaBulan: 'November'
    },
    {
        id: 12,
        namaBulan: 'Desember'
    },
]

class ReportPesertaPasif extends Component {
    constructor(props) {
        super(props)

        this.state = {
            formFilter: {
                participantId: this.props.store.getState().sessionUser.participantId,
                productId: null,
                mpPaymentTypeId: null,
                greaterPensiunDate: null,
                lessPensiunDate: null,
            },
            src: ''
        }

        this.loadData = []

        this.formRef = React.createRef()
        this.datagridRef = React.createRef()

        this.filterItem = [
            {
                itemType: 'group',
                name: 'basicFilter',
                items: [
                    {
                        itemType: 'group',
                        colCount: 5,
                        items: [
                            {
                                dataField: 'participantId',
                                label: {
                                    text: 'Pemberi Kerja',
                                },
                                colSpan: 4,
                                editorType: 'dxSelectBox',
                                editorOptions: {
                                    placeholder: ' ',
                                    dataSource: participants(this.props.store),
                                    valueExpr: "id", // contains the same values as the "statusId" field provides
                                    displayExpr: "participantName", // provides display values
                                    searchEnabled: true,
                                    deferRendering: false,
                                    elementAttr: { class: "bd-input-popup-disabled-dapen-default" },
                                    readOnly: true
                                }
                            },

                        ]
                    },
                    {
                        itemType: 'group',
                        colCount: 5,
                        items: [
                            {
                                dataField: 'productId',
                                label: {
                                    text: 'Produk',
                                },
                                colSpan: 4,
                                editorType: 'dxSelectBox',
                                editorOptions: {
                                    placeholder: ' ',
                                    dataSource: product(this.props.store),
                                    valueExpr: "id", 
                                    displayExpr: function (item) {
                                        return item && item.productCode + " - " + item.productName;
                                    },
                                    searchEnabled: true,
                                    deferRendering: false,
                                    elementAttr: { class: "bd-input-popup-dapen-default" },
                                }
                            },
                        ]
                    },
                    {
                        itemType: 'group',
                        colCount: 5,
                        items: [
                            {
                                dataField: 'greaterPensiunDate',
                                label: {
                                    text: 'Tanggal Pensiun',
                                },
                                colSpan: 2,
                                editorType: 'dxDateBox',
                                editorOptions: {
                                    useMaskBehavior: true,
                                    openOnFieldClick: true,
                                    displayFormat: 'dd MMM yyyy',
                                    elementAttr: { class: "bd-input-popup-dapen-default" },
                                }
                            },
                            {
                                dataField: 'lessPensiunDate',
                                label: {
                                    text: 'S/D',
                                },
                                colSpan: 2,
                                editorType: 'dxDateBox',
                                editorOptions: {
                                    useMaskBehavior: true,
                                    openOnFieldClick: true,
                                    displayFormat: 'dd MMM yyyy',
                                    elementAttr: { class: "bd-input-popup-dapen-default" },
                                }
                            },
                        ]
                    },
                    {
                        itemType: 'group',
                        colCount: 5,
                        items: [
                            {
                                dataField: 'mpPaymentTypeId',
                                label: {
                                    text: 'Tipe Pembayaran',
                                },
                                colSpan: 4,
                                editorType: 'dxSelectBox',
                                editorOptions: {
                                    dataSource: tipePembayaranMp(this.props.store),
                                    valueExpr: 'id',
                                    displayExpr: 'typeName',
                                    searchEnabled: true,
                                    deferRendering: false,
                                    elementAttr: { class: "bd-input-popup-dapen-default" },
                                },
                            },
                            {
                                itemType: "button",
                                buttonOptions: {
                                    text: "Filter",
                                    // type:"default",
                                    elementAttr: { class: "bg-button-popup-save-dapen-default" },
                                    onClick: () => {
                                        this.getData()
                                    },
                                },
                                horizontalAlignment: "left"
                            },
                            {
                                itemType: 'empty'
                            }
                        ]
                    }
                ]
            },
        ]

        this.columns = [
            {
                dataField: 'productId',
                caption: 'Produk',
                lookup: {
                    dataSource: product(this.props.store),
                    valueExpr: "id", // contains the same values as the "statusId" field provides
                    displayExpr: "productCode", // provides display values
                }
            },
            {
                dataField: 'participantId',
                caption: 'Pemberi Kerja',
                lookup: {
                    dataSource: participants(this.props.store),
                    valueExpr: "id", // contains the same values as the "statusId" field provides
                    displayExpr: "participantName", // provides display values
                }
            },
            {
                dataField: 'efektifDate',
                caption: 'Tanggal Pensiun',
                dataType: 'date',
                format: 'dd MMM yyyy',
            },
            {
                dataField: 'nik',
                caption: 'NIK',
            },
            {
                dataField: 'fullName',
                caption: 'Nama Lengkap',
            },
            {
                dataField: 'birthDate',
                caption: 'Tanggal Lahir',
                dataType: 'date',
                format: 'dd MMM yyyy',
            },
            // {
            //     dataField: 'statusKeluarga',
            //     caption: 'Status Keluarga',
            // },
            {
                dataField: 'pensiunType',
                caption: 'Tipe Pensiun',
                lookup: {
                    dataSource: pensiunType(this.props.store),
                    valueExpr: "id", // contains the same values as the "statusId" field provides
                    displayExpr: "statusName", // provides display values
                }
            },
            {
                dataField: 'typeName',
                caption: 'Tipe Pembayaran',
            },
            {
                dataField: 'mpBulanan',
                caption: 'Nominal MP Bulanan',
                alignment: 'right',
                dataType: 'number',
                format: '#,##0.00',
            },
            {
                dataField: 'mpSekaligus',
                caption: 'Nominal MP Sekaligus',
                alignment: 'right',
                dataType: 'number',
                format: '#,##0.00',
            },
            {
                dataField: 'penerimaName',
                caption: 'Nama Penerima',
            },
            // {
            //     dataField: 'birthDatePenerima',
            //     caption: 'Tanggal Lahir Penerima'
            // },
            // {
            //     dataField: 'jenisKelaminPenerima',
            //     caption: 'Jenis Kelamin Penerima',
            // },
            {
                dataField: 'mpRekeningNo',
                caption: 'No Rekening Penerima',
            },
            {
                dataField: 'mpRekeningName',
                caption: 'Nama Rekening Penerima',
            },
            {
                dataField: 'mpRekeningBankId',
                caption: 'Bank Penerima',
                lookup: {
                    dataSource: banks(this.props.store),
                    valueExpr: "id", // contains the same values as the "statusId" field provides
                    displayExpr: "bankName", // provides display values
                }
            }
        ]
    }

    componentWillMount = async () => {
        let store = this.props.store;
        store.dispatch(addURL(this.props.location.pathname))
    }

    forceRefresh = () => {
        this.datagridRef.current.forceRefresh(true)
    }

    getData = async () => {
        let filter = this.state.formFilter;

        if(filter.participantId || filter.productId || filter.mpPaymentTypeId || filter.greaterPensiunDate || filter.lessPensiunDate){    
            var loadAPI = `list-view-laporan-peserta-pasifs?size=9999&`

            if (filter.participantId) {
                loadAPI = loadAPI + `participantId.in=${filter.participantId}&`
            }

            if (filter.productId) {
                loadAPI = loadAPI + `productId.in=${filter.productId}&`
            }

            if (filter.mpPaymentTypeId) {
                loadAPI = loadAPI + `mpPaymentTypeId.in=${filter.mpPaymentTypeId}&`
            }

            if (filter.greaterPensiunDate) {
                loadAPI = loadAPI + `pensiunDate.greaterThanOrEqual=${formatDate(filter.greaterPensiunDate)}&`
            }

            if (filter.lessPensiunDate) {
                loadAPI = loadAPI + `pensiunDate.lessThanOrEqual=${formatDate(filter.lessPensiunDate)}&`
            }

            var getPesertaPasif = await httpRequest(process.env.REACT_APP_BACKEND_CORE, this.props.store, loadAPI.slice(0, -1), 'GET')

            this.loadData = getPesertaPasif
            this.forceRefresh()
        }else{
            this.loadData = []
            this.forceRefresh()
        }
    }

    loadDummyData = async (filter) => {
        return this.loadData
    }

    print = async () => {
        var filter = this.state.formFilter
        if(filter.participantId || filter.productId || filter.mpPaymentTypeId || filter.greaterPensiunDate || filter.lessPensiunDate){
            let store = this.props.store
            store.dispatch(showLoading(true))
            var loadAPI = `list-view-laporan-peserta-pasifs?size=9999&`
            var getProduct = await httpRequest(process.env.REACT_APP_BACKEND_CORE, this.props.store, `products`, 'GET')
            var getBanks = await httpRequest(process.env.REACT_APP_BACKEND, this.props.store, `banks`, 'GET')
            var getPensiunType = await httpRequest(process.env.REACT_APP_BACKEND_CORE, this.props.store, `pensiun-types`, 'GET')
            var getMPPenerimaType = await httpRequest(process.env.REACT_APP_BACKEND_CORE, this.props.store, `manfaat-pensiun-penerima-types`, 'GET')

            if (filter.participantId) {
                loadAPI = loadAPI + `participantId.in=${filter.participantId}&`
                try {
                    var participantName = (await httpRequest(process.env.REACT_APP_BACKEND_CORE, this.props.store, `participants/${filter.participantId}`, 'GET')).participantName
                } catch (error) {
                    var participantName = 'Semua'
                }
            } else {
                var participantName = 'Semua'
            }

            if (filter.productId) {
                loadAPI = loadAPI + `productId.in=${filter.productId}&`
            }
            var productName = getProduct.find(val => val.id == filter.productId) ? getProduct.find(val => val.id == filter.productId).productCode : 'Semua'


            if (filter.mpPaymentTypeId) {
                loadAPI = loadAPI + `mpPaymentTypeId.in=${filter.mpPaymentTypeId}&`
                try {
                    var mpPaymentTypeName = (await httpRequest(process.env.REACT_APP_BACKEND_CORE, this.props.store, `mp-payment-types/${filter.mpPaymentTypeId}`, 'GET')).typeName
                } catch (error) {
                    var mpPaymentTypeName = 'Semua'
                }
            }

            // Tanggal Pensiun
            if (filter.greaterPensiunDate) {
                loadAPI = loadAPI + `pensiunDate.greaterThanOrEqual=${formatDate(filter.greaterPensiunDate)}&`
            }

            if (filter.lessPensiunDate) {
                loadAPI = loadAPI + `pensiunDate.lessThanOrEqual=${formatDate(filter.lessPensiunDate)}&`
            }

            var getPesertaPasif = await httpRequest(process.env.REACT_APP_BACKEND_CORE, this.props.store, loadAPI.slice(0, -1), 'GET')
            var getKp = await httpRequest(process.env.REACT_APP_BACKEND_CORE, this.props.store, 'kepersertaan-products?size=9999', 'GET')

            var arrQtyBulanan = []
            var arrQtySekaligus = []
            for (var value of getPesertaPasif) {
                let findPenerimaType = getMPPenerimaType.find(data => data.id === value.mpPenerimaTypeId)
                value.mpPenerimaTypeId = findPenerimaType ? findPenerimaType.penerimaName : '-'

                let findPensiunType = getPensiunType.find(data => data.id === value.pensiunType)
                value.pensiunType = findPensiunType ? findPensiunType.statusName : '-'

                // var month = bulan.find(val => val.id == value.mkBulan)
                // value.mkBulan = month ? month.namaBulan : '-'

                var productDetailName = getProduct.find(val => val.id == value.productId).productCode
                value.productId = productDetailName || '-'

                var bankName = getBanks.find(val => val.id == value.mpRekeningBankId)
                value.mpRekeningBankId = bankName ? bankName.initialName : '-'

                var arrKp = getKp.find(val => val.pesertaId === value.pesertaId)
                value.nsPeriode = arrKp ? arrKp.nsPeriode : 0

                let totalMpBulanan = value.mpBulanan
                let totalMpSekaligus = value.mpSekaligus

                arrQtyBulanan.push(totalMpBulanan)
                arrQtySekaligus.push(totalMpSekaligus)
            }

            var qtyBulanan = arrQtyBulanan.reduce((a, b) => a + b)
            var qtySekaligus = arrQtySekaligus.reduce((a, b) => a + b)
            var data = {
                template: {
                    name: '/dapen/kepesertaan/report/peserta/peserta-pasif',
                    recipe: 'html'
                },
                data: {
                    tanggalLaporan: formatDefaultDate(new Date()),
                    product: productName,
                    mpPaymentType: mpPaymentTypeName,
                    participant: participantName,
                    tanggalPensiun: filter.lessPensiunDate && filter.greaterPensiunDate ? (filter.greaterPensiunDate ? formatDefaultDate(filter.greaterPensiunDate) : "~") + ' S/D ' + (filter.lessPensiunDate ? formatDefaultDate(filter.lessPensiunDate) : "~") : 'Semua',
                    dataPeserta: getPesertaPasif,
                    qtyBulanan: qtyBulanan,
                    qtySekaligus: qtySekaligus
                }
            }
            var response = await reportRequest(this.props.store, data)
            store.dispatch(showLoading(false))
            PrintElem(response.data)
            return response
        }else{
            notify({ message: 'Silahkan Filter Data Terlebih Dahulu', width: "AUTO", shading: true, position: { at: "center", my: "center", of: window } }, 'error', 3000);
        } 
    }

    exportExcel = async () => {
        var filter = this.state.formFilter
        if(filter.participantId || filter.productId || filter.mpPaymentTypeId || filter.greaterPensiunDate || filter.lessPensiunDate) {
            var data = []
            let store = this.props.store
            try {
                store.dispatch(showLoading(true))
                var loadAPI = `list-view-laporan-peserta-pasifs?size=9999&`
                var getProduct = await httpRequest(process.env.REACT_APP_BACKEND_CORE, this.props.store, `products`, 'GET')
                var getBanks = await httpRequest(process.env.REACT_APP_BACKEND, this.props.store, `banks`, 'GET')
                var getPensiunType = await httpRequest(process.env.REACT_APP_BACKEND_CORE, this.props.store, `pensiun-types`, 'GET')
                var getMPPenerimaType = await httpRequest(process.env.REACT_APP_BACKEND_CORE, this.props.store, `manfaat-pensiun-penerima-types`, 'GET')

                if (filter.participantId) {
                    loadAPI = loadAPI + `participantId.in=${filter.participantId}&`
                    try {
                        var participantName = (await httpRequest(process.env.REACT_APP_BACKEND_CORE, this.props.store, `participants/${filter.participantId}`, 'GET')).participantName
                    } catch (error) {
                        var participantName = 'Semua'
                    }
                } else {
                    var participantName = 'Semua'
                }

                if (filter.productId) {
                    loadAPI = loadAPI + `productId.in=${filter.productId}&`
                }
                var productName = getProduct.find(val => val.id == filter.productId) ? getProduct.find(val => val.id == filter.productId).productCode : 'Semua'


                if (filter.mpPaymentTypeId) {
                    loadAPI = loadAPI + `mpPaymentTypeId.in=${filter.mpPaymentTypeId}&`
                    try {
                        var mpPaymentTypeName = (await httpRequest(process.env.REACT_APP_BACKEND_CORE, this.props.store, `mp-payment-types/${filter.mpPaymentTypeId}`, 'GET')).typeName
                    } catch (error) {
                        var mpPaymentTypeName = 'Semua'
                    }
                }

                // Tanggal Pensiun
                if (filter.greaterPensiunDate) {
                    loadAPI = loadAPI + `pensiunDate.greaterThanOrEqual=${formatDate(filter.greaterPensiunDate)}&`
                }

                if (filter.lessPensiunDate) {
                    loadAPI = loadAPI + `pensiunDate.lessThanOrEqual=${formatDate(filter.lessPensiunDate)}&`
                }

                var getPesertaPasif = await httpRequest(process.env.REACT_APP_BACKEND_CORE, this.props.store, loadAPI.slice(0, -1), 'GET')
                var getKp = await httpRequest(process.env.REACT_APP_BACKEND_CORE, this.props.store, 'kepersertaan-products?size=9999', 'GET')

                var index = 1
                for (var value of getPesertaPasif) {
                    let findPenerimaType = getMPPenerimaType.find(data => data.id === value.mpPenerimaTypeId)
                    value.mpPenerimaTypeId = findPenerimaType ? findPenerimaType.penerimaName : '-'

                    let findPensiunType = getPensiunType.find(data => data.id === value.pensiunType)
                    value.pensiunType = findPensiunType ? findPensiunType.statusName : '-'

                    // var month = bulan.find(val => val.id == value.mkBulan)
                    // value.mkBulan = month ? month.namaBulan : '-'

                    var productDetailName = getProduct.find(val => val.id == value.productId).productCode
                    value.productId = productDetailName || '-'

                    var bankName = getBanks.find(val => val.id == value.mpRekeningBankId)
                    value.mpRekeningBankId = bankName ? bankName.initialName : '-'

                    var arrKp = getKp.find(val => val.pesertaId === value.pesertaId)
                    value.nsPeriode = arrKp ? arrKp.nsPeriode : 0

                    var dataValue = {
                        id: index++,
                        nik: value.nik,
                        fullName: value.fullName,
                        birthPlace: value.birthPlace,
                        birthDate: value.birthDate ? formatDefaultDate(value.birthDate) : '-',
                        pensiunType: value.pensiunType,
                        pensiunDate: value.pensiunDate ? formatDefaultDate(value.pensiunDate) : '-',
                        mkTahun: value.mkTahun,
                        mkBulan: value.mkBulan,
                        productId: productDetailName || '-',
                        typeName: value.typeName,
                        mpBulanan: value.mpBulanan ? formatNumber(value.mpBulanan) : '0',
                        mpSekaligus: value.mpSekaligus ? formatNumber(value.mpSekaligus) : '0',
                        mpPenerimaTypeId: value.mpPenerimaTypeId,
                        penerimaName: value.penerimaName,
                        mpRekeningNo: value.mpRekeningNo,
                        mpRekeningName: value.mpRekeningName,
                        mpRekeningBankId: bankName ? bankName.initialName : '-',
                        nsPeriode: arrKp ? arrKp.nsPeriode : 0
                    }

                    const objectValue = Object.values(dataValue)

                    data.push(objectValue)
                }

                try {
                    const workbook = new Excel.Workbook();
                    var worksheet = workbook.addWorksheet('DAFTAR PESERTA PASIF');
                    worksheet.addTable({
                        name: 'MyTable',
                        ref: 'A12',
                        headerRow: true,
                        totalsRow: false,
                        style: {
                            theme: 'TableStyleLight15',
                            showFirstColumn: true,
                            // border: {
                            //     top: {style:'thin'},
                            //     left: {style:'thin'},
                            //     bottom: {style:'thin'},
                            //     right: {style:'thin'}
                            // }
                        },
                        columns: [
                            { name: 'No' },
                            { name: 'NIK' },
                            { name: 'Nama' },
                            { name: 'Tempat Lahir' },
                            { name: 'Tanggal Lahir' },
                            { name: 'Tipe Pensiun' },
                            { name: 'Tanggal Pensiun' },
                            { name: 'MK Tahun' },
                            { name: 'MK Bulan' },
                            { name: 'Product' },
                            { name: 'Tipe Pembayaran' },
                            { name: 'Nominal Mp Bulanan' },
                            { name: 'Nominal Mp Sekaligus' },
                            { name: 'Penerima' },
                            { name: 'Hubungan Keluarga' },
                            { name: 'Rekening No' },
                            { name: 'Rekening Nama' },
                            { name: 'Rekening Bank' },
                            { name: 'Periode' },
                        ],
                        rows: data,
                    });

                    worksheet.getCell('A1').value = 'NAYAGA DANA PENSIUN'

                    worksheet.getCell('A3').value = 'Kode'
                    worksheet.getCell('B3').value = `: KPS-2-02`

                    worksheet.getCell('A4').value = 'Laporan'
                    worksheet.getCell('B4').value = `: DAFTAR PESERTA PASIF`

                    worksheet.getCell('A5').value = 'Tanggal Laporan'
                    worksheet.getCell('B5').value = `: ${formatDefaultDate(new Date())}`

                    worksheet.getCell('A7').value = 'Pemberi Kerja'
                    worksheet.getCell('B7').value = `: ${participantName}`

                    worksheet.getCell('A8').value = 'Product'
                    worksheet.getCell('B8').value = `: ${productName}`

                    worksheet.getCell('A9').value = 'Tanggal Pensiun'
                    worksheet.getCell('B9').value = `: ${filter.lessPensiunDate && filter.greaterPensiunDate ? (filter.greaterPensiunDate ? formatDefaultDate(filter.greaterPensiunDate) : "~") + ' S/D ' + (filter.lessPensiunDate ? formatDefaultDate(filter.lessPensiunDate) : "~") : 'Semua'}`

                    worksheet.getCell('A10').value = 'Tipe Pembayaran MP'
                    worksheet.getCell('B10').value = `: ${mpPaymentTypeName}`

                    worksheet.getCell('A12').alignment = { vertical: 'middle', horizontal: 'center' };
                    worksheet.getCell('B12').alignment = { vertical: 'middle', horizontal: 'center' };
                    worksheet.getCell('C12').alignment = { vertical: 'middle', horizontal: 'center' };
                    worksheet.getCell('D12').alignment = { vertical: 'middle', horizontal: 'center' };
                    worksheet.getCell('E12').alignment = { vertical: 'middle', horizontal: 'center' };
                    worksheet.getCell('F12').alignment = { vertical: 'middle', horizontal: 'center' };
                    worksheet.getCell('G12').alignment = { vertical: 'middle', horizontal: 'center' };
                    worksheet.getCell('H12').alignment = { vertical: 'middle', horizontal: 'center' };
                    worksheet.getCell('I12').alignment = { vertical: 'middle', horizontal: 'center' };
                    worksheet.getCell('J12').alignment = { vertical: 'middle', horizontal: 'center' };
                    worksheet.getCell('K12').alignment = { vertical: 'middle', horizontal: 'center' };
                    worksheet.getCell('L12').alignment = { vertical: 'middle', horizontal: 'center' };
                    worksheet.getCell('M12').alignment = { vertical: 'middle', horizontal: 'center' };
                    worksheet.getCell('N12').alignment = { vertical: 'middle', horizontal: 'center' };
                    worksheet.getCell('O12').alignment = { vertical: 'middle', horizontal: 'center' };
                    worksheet.getCell('P12').alignment = { vertical: 'middle', horizontal: 'center' };
                    worksheet.getCell('Q12').alignment = { vertical: 'middle', horizontal: 'center' };
                    worksheet.getCell('R12').alignment = { vertical: 'middle', horizontal: 'center' };
                    worksheet.getCell('S12').alignment = { vertical: 'middle', horizontal: 'center' };

                    for (var i = 13; i <= 10000; i++) {
                        worksheet.getCell('A' + i).alignment = { vertical: 'middle', horizontal: 'center' };
                        worksheet.getCell('B' + i).alignment = { vertical: 'middle', horizontal: 'left' };
                        worksheet.getCell('C' + i).alignment = { vertical: 'middle', horizontal: 'left' };
                        worksheet.getCell('D' + i).alignment = { vertical: 'middle', horizontal: 'left' };
                        worksheet.getCell('E' + i).alignment = { vertical: 'middle', horizontal: 'left' };
                        worksheet.getCell('F' + i).alignment = { vertical: 'middle', horizontal: 'left' };
                        worksheet.getCell('G' + i).alignment = { vertical: 'middle', horizontal: 'left' };
                        worksheet.getCell('H' + i).alignment = { vertical: 'middle', horizontal: 'left' };
                        worksheet.getCell('I' + i).alignment = { vertical: 'middle', horizontal: 'left' };
                        worksheet.getCell('J' + i).alignment = { vertical: 'middle', horizontal: 'left' };
                        worksheet.getCell('K' + i).alignment = { vertical: 'middle', horizontal: 'left' };
                        worksheet.getCell('L' + i).alignment = { vertical: 'middle', horizontal: 'left' };
                        worksheet.getCell('M' + i).alignment = { vertical: 'middle', horizontal: 'left' };
                        worksheet.getCell('N' + i).alignment = { vertical: 'middle', horizontal: 'left' };
                        worksheet.getCell('O' + i).alignment = { vertical: 'middle', horizontal: 'left' };
                        worksheet.getCell('P' + i).alignment = { vertical: 'middle', horizontal: 'left' };
                        worksheet.getCell('R' + i).alignment = { vertical: 'middle', horizontal: 'left' };
                        worksheet.getCell('S' + i).alignment = { vertical: 'middle', horizontal: 'left' };
                    }

                    var WidthColums = 20;

                    const Data1 = worksheet.getColumn(1);
                    Data1.width = WidthColums;

                    const Data2 = worksheet.getColumn(2);
                    Data2.width = WidthColums;

                    const Data3 = worksheet.getColumn(3);
                    Data3.width = 30;

                    const Data4 = worksheet.getColumn(4);
                    Data4.width = WidthColums;

                    const Data5 = worksheet.getColumn(5);
                    Data5.width = WidthColums;

                    const Data6 = worksheet.getColumn(6);
                    Data6.width = WidthColums;

                    const Data7 = worksheet.getColumn(7);
                    Data7.width = 60;

                    const Data8 = worksheet.getColumn(8);
                    Data8.width = WidthColums;

                    const Data9 = worksheet.getColumn(9);
                    Data9.width = 30;

                    const Data10 = worksheet.getColumn(10);
                    Data10.width = WidthColums;

                    const Data11 = worksheet.getColumn(11);
                    Data11.width = WidthColums;

                    const Data12 = worksheet.getColumn(12);
                    Data12.width = WidthColums;

                    const Data13 = worksheet.getColumn(13);
                    Data13.width = WidthColums;

                    const Data14 = worksheet.getColumn(14);
                    Data14.width = WidthColums;

                    const Data15 = worksheet.getColumn(15);
                    Data15.width = WidthColums;

                    const Data16 = worksheet.getColumn(16);
                    Data16.width = WidthColums;

                    const Data17 = worksheet.getColumn(17);
                    Data17.width = WidthColums;

                    const Data18 = worksheet.getColumn(18);
                    Data18.width = WidthColums;

                    const Data19 = worksheet.getColumn(19);
                    Data19.width = 10;

                    await workbook.xlsx.writeBuffer().then(function (buffer) {
                        saveAs(
                            new Blob([buffer], { type: "application/octet-stream" }),
                            `LAPORAN_PESERTA_PASIF.xlsx`
                        );
                    });
                } catch (e) {
                    console.log(e)
                }
                store.dispatch(showLoading(false))
            } catch (e) {
                store.dispatch(showLoading(false))
                console.log(e)
            }
        }else{
            notify({ message: 'Silahkan Filter Data Terlebih Dahulu', width: "AUTO", shading: true, position: { at: "center", my: "center", of: window } }, 'error', 3000);
        }
    }

    onToolbarPreparing = (e) => {
        e.toolbarOptions.items.unshift(
            {
                location: 'after',
                widget: 'dxButton',
                options: {
                    elementAttr: { class: "bg-button-add-dapen-default" },
                    icon: 'print',
                    text: 'Cetak Data',
                    onClick: this.print.bind(this)
                }
            },
            {
                location: 'after',
                widget: 'dxButton',
                options: {
                    elementAttr: { class: "bg-button-export-dapen-default" },
                    icon: 'print',
                    text: 'Export Excel',
                    onClick: this.exportExcel.bind(this)
                }
            }
        )
    }

    buttonAttributes = () => {
        return {
            class: "bg-button-popup-save-dapen-default"
        }
    }

    render() {
        return (
            <div className="container-fluid">
                <h4 className="main-title"> Daftar Peserta Pasif </h4>
                <div className="row">
                    <div className="col-md-6">
                        <Form
                            ref={this.formRef}
                            colCount={1}
                            id={'formDataMaster'}
                            formData={this.state.formFilter}
                            items={this.filterItem}
                            labelLocation='left'
                        />
                    </div>
                </div>
                
                <DevExpressDataGrid
                    ref={this.datagridRef}
                    loadAPI={``}
                    insertAPI='-'
                    updateAPI='-'
                    deleteAPI='-'

                    backendserver={process.env.REACT_APP_BACKEND_CORE}

                    useArraySource={true}
                    ArraySourceData={this.loadDummyData}

                    allowAdding={false}
                    allowDeleting={false}
                    allowUpdating={false}
                    exportExcel={false}
                    exportFileName={"Hasil Investasi"}
                    allowExportSelectedData={true}
                    selection={'multiple'}

                    showBorders={true}
                    height={'60vh'}
                    paging={true}
                    defaultPageSize={20}

                    //bagian konfigurasi popup saat insert dan edit record
                    popupTitle={'Report Data'}
                    popupWidth={500} //masukan dalam ukuran pixel
                    popupHeight={200} //masukkan dalam ukuran pixel

                    popupFormLabelLocation='left' //accepted value = top, left, right
                    popupFormMinColWidth={300} // minimum lebar kolom
                    popupFormColCount={1} //jumlah kolom pada form

                    //akhir bagian konfigurasi popup

                    ColumnChooser={false} // set false agar kolom tidak dapat di pindah pindah
                    ColumnFixing={true} // set false agar kolom tidak dapat di freeze

                    FilterRow={true} // set false untuk mematikan fitur filter

                    ColumnConfiguration={this.columns} // taruh konfigurasi kolom disini
                    // SummaryConfiguration={this.summary}

                    onToolbarPreparing={this.onToolbarPreparing}

                    //contoh konfigurasi kolom
                    //this.columns = [{
                    //    dataField: 'kolom1',
                    //    caption: 'Ini Kolom 1'
                    //}, {
                    //    dataField: 'kolom2',
                    //    caption: 'Ini Kolom 2'
                    //}]
                    // detail konfigurasi dapat dilihat di https://js.devexpress.com/Documentation/ApiReference/UI_Widgets/dxDataGrid/Configuration/columns/

                    store={this.props.store} // jangan di edit edit
                />
            </div>
        )
    }
}

export default ReportPesertaPasif